const VisualistaionPlayer = () => {
    return (
        <div className="w-full h-full flex justify-center items-center text-white">
            <h1>VisualistaionPlayer</h1>
        </div>
    )
}

export default VisualistaionPlayer;